import React from "react";

export default function WalletFundingBanner({ onFund }) {
  return (
    <div
      style={{
        backgroundColor: "#4e8cff", // main app blue
        color: "#fff",
        padding: "1rem 1.5rem",
        borderRadius: "6px",
        marginBottom: "1rem",
        fontSize: "0.95rem",
        lineHeight: "1.5",
      }}
    >
      <p style={{ margin: 0, marginBottom: "0.75rem" }}>
        <strong>Let's get started!</strong>
        <br />
        Unlink runs on Solana, a decentralized network. To send messages, your wallet needs a couple of dollars worth of SOL (Solana’s currency) to cover network fees. Your balance is currently empty.
      </p>

      <button
        onClick={onFund}
        style={{
          backgroundColor: "#4e8cff",
          color: "#fff",
          border: "1px solid #fff",
          borderRadius: "6px",
          padding: "0.5rem 1.25rem",
          fontSize: "0.95rem",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        Fund Your Wallet Now
      </button>
    </div>
  );
}